<template>
    <div class="header w-100">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a href="#" class="img-logo">
            <img src="@/assets/logo.png" style="width:100px"/>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div v-if="login" class="collapse navbar-collapse header-bar barra-opciones" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li>
                <a href="#"><router-link to="/">Home</router-link></a>
            </li>
            <li>
                <a href="#"><router-link to="/">My Account</router-link></a>
            </li>
            <li>
                <a href="#"><router-link to="/AdviserHub">Adviser Hub</router-link></a>
            </li>
            <li>
                <a href="#"><router-link to="/calculator">Calculator</router-link></a>
            </li>
          </ul>
          <ul>
            <li>
              <a v-on:click='logOut()' :class="(header==4) ? 'active mr-3' : 'mr-3' " href="#">LogOut</a>
            </li>
          </ul>          
        </div>
        <div v-else class="collapse navbar-collapse header-bar barra-opciones" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li>
                <a href="#"><router-link to="/">Home</router-link></a>
            </li>
            <li>
                <a href="#"><router-link to="/calculator">Calculator</router-link></a>
            </li>
            <li>
                <a href="#"><router-link to="/contactus">Contact US</router-link></a>
            </li>
          </ul>
          <ul>
            <li>
              <a href="#"><router-link to="/login">LogIn</router-link></a>
            </li>
          </ul>          
        </div>
      </nav>
    </div>
</template>
<script>
import {mapState,mapActions} from 'vuex'
export default {
    name:'Header',
    data(){
      return{
        
      }
    },
    methods:{
      ...mapActions(['actOutLogin']),
      logOut(){
        this.actOutLogin();
        this.$router.push({ path: '/login' });
      }
       
    },
  computed:{
      ...mapState(['header','login'])
  },
}
</script>
<style scoped>
.header-bar{
  padding-bottom: 20px;

}
.header-bar ul{
  margin-top: 35px;
  margin-right: 30px;
}
.header-bar li{
  list-style: none;
  margin-right: 14px;
  

}
.header-bar a{
  font-size: 14px;
  font-family: 'Abel', sans-serif!important;
  cursor: pointer;
}
.img-logo{
  padding-left: 30px;
}
a:hover{
  text-decoration: none!important;
}
.barra-opciones a{
  position: relative;
  z-index: 1;
  color: black;
  border: none;
  margin-left: 20px;
}
.barra-opciones a::before{
  position: absolute;
  left: 49%;
  content: '';
  display: block;
  width: 50%;
  height: 10%;
  background-color: #C41823;
  z-index: -1;
  transform: scaleX(0);
  transition: transform .7s
}
.barra-opciones a::before{
  top: 100%;
  transform-origin: left;
}
.barra-opciones a::after{
  position: absolute;
  left: 0;
  content: '';
  display: block;
  width: 50%;
  height: 10%;
  background-color: #C41823;
  z-index: -1;
  transform: scaleX(0);
  transition: transform .7s
}
.active{
 border-bottom: 1.2px solid #C41823!important;
}
.barra-opciones a::after{
  top: 100%;
  transform-origin: right;
}
.barra-opciones a:hover::before{
  transform: scaleX(1);

}
.barra-opciones a:hover::after{
  transform: scaleX(1);

}
</style>